import {history} from 'client/history';

/**
 * @param questionSetSlug
 * @param questionSlug
 * @todo Ideally the callers of this function can just rely directly
 * on model/extension methods in the future (removing the need for this file).
 * @returns function to push to direct question link
 */
export function makeNavigateToQuestion(questionSetSlug: string, questionSlug: string): () => void {
  const splitSlug: string[] = questionSetSlug.split('@');
  const subjectSlug: string = splitSlug[0];
  return (): void => {
    history.pushState(null, `/learn/question/${subjectSlug}/${questionSlug}`);
  };
}

export const formatClassroomCodeForDisplay = (code: string) => {
  if (!code) return code;

  // Invite codes were recently shortened from 12 to 6 characters.
  // Only the 6 character codes should be split with a hyphen.
  // Because the old codes will persist until they are regenerated, we must do a check to confirm
  // if the code requires the special formatting.
  if (code.length === 6) {
    return `${code.slice(0, 3)}-${code.slice(3)}`;
  }

  return code;
};
